import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=38b44919&scoped=true&"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js&"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingDocument.vue?vue&type=style&index=0&id=38b44919&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b44919",
  null
  
)

export default component.exports